import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ActSummaryComp from "./Component/ActSummaryComp"


const ActSummary =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ActSummaryComp />
        </div>
        <Footer />
        </>
    )
}

export default ActSummary